import React, { useState } from 'react';
import ConpanyName_Image from '../assets/company_name.png';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="w-full bg-white/90 backdrop-blur-md shadow-lg sticky top-0 left-0 z-50 font-body">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <div className="flex items-center space-x-3 group">
          {/* <div className="relative">
            <img src={StarAI_Logo} alt="StarAI Logo" className="h-10 w-10 group-hover:scale-110 transition-transform duration-300" />
            <div className="absolute inset-0 bg-brand-primary rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </div>
          <span className="font-display font-black text-h5 text-brand-dark tracking-tight group-hover:text-brand-secondary transition-colors">
            Star<span className="text-brand-primary group-hover:text-brand-secondary transition-colors">AI</span>
          </span> */}
          <img src={ConpanyName_Image} alt="StarAI Logo" className="h-12 group-hover:scale-110 transition-transform duration-300" />
        </div>
        
        {/* Navigation Links */}
        <div className="hidden md:flex space-x-8 text-body font-medium">
          <a href="#home" className="text-gray-700 hover:text-brand-primary transition-colors duration-300 relative group">
            Trang chủ
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-primary group-hover:w-full transition-all duration-300"></span>
          </a>
          <a href="#solutions" className="text-gray-700 hover:text-brand-primary transition-colors duration-300 relative group">
            Giải pháp AI
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-primary group-hover:w-full transition-all duration-300"></span>
          </a>
          <a href="#intro" className="text-gray-700 hover:text-brand-primary transition-colors duration-300 relative group">
            Tư vấn
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-primary group-hover:w-full transition-all duration-300"></span>
          </a>
          <a href="#training" className="text-gray-700 hover:text-brand-primary transition-colors duration-300 relative group">
            Đào tạo
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-primary group-hover:w-full transition-all duration-300"></span>
          </a>
          <a href="#about" className="text-gray-700 hover:text-brand-primary transition-colors duration-300 relative group">
            Về chúng tôi
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-primary group-hover:w-full transition-all duration-300"></span>
          </a>
        </div>
        
        {/* Contact Button */}
        <div className="flex items-center space-x-4">
          <a href="#contact" className="px-6 py-3 rounded-2xl bg-brand-primary text-white font-display font-semibold text-button tracking-wide shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 hover:bg-brand-secondary">
            Liên Hệ
          </a>
          
          {/* Mobile menu button */}
          <button 
            className="md:hidden p-2 rounded-lg hover:bg-brand-primary/10 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
      
      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-brand-primary/20">
          <div className="px-4 py-2 space-y-1">
            <a href="#home" className="block px-3 py-2 text-body text-gray-700 hover:text-brand-primary hover:bg-brand-primary/10 rounded-lg transition-colors font-body">Trang chủ</a>
            <a href="#solutions" className="block px-3 py-2 text-body text-gray-700 hover:text-brand-primary hover:bg-brand-primary/10 rounded-lg transition-colors font-body">Giải pháp AI</a>
            <a href="#intro" className="block px-3 py-2 text-body text-gray-700 hover:text-brand-primary hover:bg-brand-primary/10 rounded-lg transition-colors font-body">Tư vấn</a>
            <a href="#training" className="block px-3 py-2 text-body text-gray-700 hover:text-brand-primary hover:bg-brand-primary/10 rounded-lg transition-colors font-body">Đào tạo</a>
            <a href="#about" className="block px-3 py-2 text-body text-gray-700 hover:text-brand-primary hover:bg-brand-primary/10 rounded-lg transition-colors font-body">Về chúng tôi</a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar; 